import { InputValidationService } from '../../../core/services/input-validation.service';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { OnSaveData } from '../../interfaces/on-save-data';
import { NgSwitch } from '@angular/common';
import { CaseStakeholder } from '@cupoui/shared/model/caseStakeholder';
import { ValidationTypeEnum } from '@cupoui/shared/model/enumerations/validation-type.enum';
import { StakeholderService } from '@cupoui/core/services/stakeholder.service';
import { StakeholderTypeEnum } from '@cupoui/shared/model/enumerations/stakeholder-type.enum';

@Component({
    selector: 'app-drop-down-stakeholder-with-icon',
    templateUrl: './drop-down-stakeholder-with-icon.component.html',
    styleUrls: ['./drop-down-stakeholder-with-icon.component.scss'],
    providers: [NgSwitch],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DropDownStakeholderWithIconComponent implements OnInit, OnSaveData {
  @Input() name: string;
  @Input() standardDropdownIcon: boolean;
  @Input() sortingStyle: boolean;
  @Input() items: CaseStakeholder[];
  @Input() withCountryFlag: boolean;
  @Input() countries: string[];
  @Input() selectedItemId: CaseStakeholder;
  @Input() validate: boolean;
  @Input() disabled: boolean;
  @Input() required: boolean;
  @Input() validationType: ValidationTypeEnum;
  @Input() requiredRedBackground: boolean = false;
  @Input() noArrowOnDisabled: boolean;
  @Output() selectedItemIdChange = new EventEmitter();
  @Output() saveModel = new EventEmitter();
  @Output() open = new EventEmitter();

  oldSelectedItemId: CaseStakeholder;
  constructor(private inputValidationService: InputValidationService, private stakeholderService: StakeholderService) {}

  onChange() {
    this.selectedItemIdChange.emit(this.selectedItemId);
  }

  onOpen() {
    this.open.emit();
  }

  ngOnInit() {}

  onSaveModel() {
    if (this.oldSelectedItemId !== this.selectedItemId) {
      this.saveModel.emit();
    }
  }
  onSaveState() {
    this.oldSelectedItemId = this.selectedItemId;
  }

  isValidated(val: any) {
    return this.inputValidationService.isValidated(val, this.validationType);
  }

  getStakeholderIconType(stakeholder: CaseStakeholder) {
    let type = stakeholder.stakeholderType;
    if (stakeholder.hasRole(StakeholderTypeEnum.endUser)) {
      type = StakeholderTypeEnum.endUser;
    } else if (stakeholder.hasRole(StakeholderTypeEnum.policyHolder)) {
      type = StakeholderTypeEnum.policyHolder;
    }
    return '/content/icons/' + this.stakeholderService.addIconToCaseStakeholder(type) + '.svg';
  }

  isRequired() {
    return this.required && this.selectedItemId == null;
  }

  getStakeholderDisplayName(item: CaseStakeholder) {
    if (item.company) {
      return item.company.name || '';
    } else {
      return [item.person.firstName, item.person.surname].filter(Boolean).join(' ');
    }
  }
}
